import { render, staticRenderFns } from "./gallery-card.vue?vue&type=template&id=68841452&scoped=true&"
import script from "./gallery-card.vue?vue&type=script&lang=js&"
export * from "./gallery-card.vue?vue&type=script&lang=js&"
import style0 from "./gallery-card.vue?vue&type=style&index=0&id=68841452&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68841452",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
